import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  expenses: [],
  recevablePayable: [],
  incomeAndExpensesByMonths: [],
  providentFund: [],
  loading: false,
  error: false,
  success: false,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/components/Syndicates/Syndicate/Dashboard/index.js